import { useParams } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/Header";
import NavBar from "../../components/common/NavBar";
import SideSectionFrame from "../../components/common/SideSectionFrame";
import { useState } from "react";
import { ProposerInfoLoading } from "../../components/proposer/ProposerInfo";
import { useAllProposalsData, useSingleProposerData } from "../../lib/hooks";
import {
  ProposalCard,
  ProposalCardLoading,
} from "../../components/proposal/ProposalCard";
import {
  Alert,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ProposalFormType } from "../../lib/proposalAPI";
import { SingleProposerFormType } from "../../lib/proposerAPI";
import { ProposerCard } from "../../components/proposer/ProposerCard";

const SingleProposerIndex = () => {
  let params = useParams();
  const proposerid: number = +params.userid!;
  const [formData, setFormData] = useState<ProposalFormType>({
    num_per_page: 12,
    page_number: 1,
    user_id: proposerid,
  });

  const cards = [1, 2, 3, 4];

  const proposerFormData: SingleProposerFormType = { user_id: proposerid };

  const changeNumberPerPage = (event: SelectChangeEvent) => {
    setFormData({
      ...formData,
      num_per_page: parseInt(event.target.value),
    });
  };

  const {
    loading: proposalLoading,
    proposalData,
    error: proposalError,
  } = useAllProposalsData(formData);

  const {
    loading: proposerLoading,
    proposerData,
    error: proposerEror,
  } = useSingleProposerData(proposerFormData);

  return (
    <>
      <NavBar />
      <Header pageName="Proposer Information" />
      <SideSectionFrame
        leftSection={
          <>
            {proposerLoading && <ProposerInfoLoading />}
            {!proposerLoading && proposerEror && (
              <>
                <Alert severity="error">{proposerEror}</Alert>
              </>
            )}
            {!proposerLoading && proposerEror === null && (
              <Box sx={{ mt: 4 }}>
                <ProposerCard {...proposerData} />
              </Box>
            )}
          </>
        }
        rightSection={
          <>
            {proposalLoading && (
              <Grid
                container
                spacing={4}
                sx={{ justifyContent: "flex-start", pt: 5 }}
              >
                {cards.map((item) => (
                  <Grid
                    xs={12}
                    xl={4}
                    lg={6}
                    md={12}
                    sm={6}
                    item
                    key={item}
                    sx={{ display: "flex", alignSelf: "100%" }}
                  >
                    <ProposalCardLoading />
                  </Grid>
                ))}
              </Grid>
            )}

            {!proposalLoading && proposalError && (
              <>
                <Alert severity="error">{proposalError}</Alert>
              </>
            )}

            {!proposalLoading && proposalError === null && (
              <>
                <Grid
                  container
                  spacing={4}
                  sx={{ justifyContent: "flex-start", pt: 5 }}
                >
                  {Array.isArray(proposalData.items) &&
                    proposalData.items.map((item, index) => (
                      <Grid
                        xs={12}
                        xl={4}
                        lg={6}
                        md={12}
                        sm={6}
                        item
                        key={index}
                        sx={{ display: "flex", alignSelf: "100%" }}
                      >
                        <ProposalCard {...item} />
                      </Grid>
                    ))}
                </Grid>
                <div className="pullRight">
                  <Box className="paginationContainer">
                    <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                      <InputLabel id="demo-select-small">Per Page:</InputLabel>
                      <Select
                        labelId="demo-select-small"
                        id="demo-select-small"
                        name="numberPerPage"
                        value={formData.num_per_page.toString()}
                        label="Per Page"
                        onChange={changeNumberPerPage}
                      >
                        <MenuItem value={"4"}>4</MenuItem>
                        <MenuItem value={"8"}>8</MenuItem>
                        <MenuItem value={"12"}>12</MenuItem>
                        <MenuItem value={"16"}>16</MenuItem>
                        <MenuItem value={"20"}>20</MenuItem>
                      </Select>
                    </FormControl>
                    <Pagination
                      count={Math.ceil(
                        proposalData.number_of_rows / formData.num_per_page
                      )}
                      onChange={(
                        event: React.ChangeEvent<unknown>,
                        value: number
                      ) => {
                        setFormData({
                          ...formData,
                          page_number: value,
                        });
                      }}
                      page={formData.page_number}
                    />
                  </Box>
                </div>
              </>
            )}
          </>
        }
      ></SideSectionFrame>

      <Footer />
    </>
  );
};

export default SingleProposerIndex;
